import React from 'react';
import {bem} from '../../utils/bem';

const block = bem('block');

const Block = ({children = null, modifiers = {}, ...restProps}) => (
	<section
		className={block(modifiers)}
		{...restProps}>
		<div className={block('container')}>
			<div className={block('content')}>
				{ children }
			</div>
		</div>
	</section>
);

export default Block;
